import LazyHelper from '../helpers/lazy-helper';

const InitWistiaVideo = {
    init: function () {
        document.addEventListener("DOMContentLoaded", function () {
            let isEventListenerAttached = false;
            if (getScrollFromTopValue() <= 0) {
                loadWistiaScript();
            }
            else {
                isEventListenerAttached = true;
                window.addEventListener('scroll', loadWistiaScript);
                window.addEventListener('lazy-load', function (e) {
                    loadWistiaScript(true);
                 }, false);
            }

            

            function loadWistiaScript(forceLoad) {
                if (getScrollFromTopValue() <= 0 || forceLoad) {
                    {
                        if (isEventListenerAttached) {
                            window.removeEventListener('scroll', loadWistiaScript);
                        }

                        if (!document.getElementById('wistia-script')) {
                            LazyHelper.addScriptFile('https://fast.wistia.com/assets/external/E-v1.js', 'wistia-script', true);
                        }
                    }
                };
            }

            function getScrollFromTopValue() {
                let wistiaEmbed = document.getElementsByClassName('wistia_embed');
                if (wistiaEmbed.length > 0) {
                    return wistiaEmbed[0].getBoundingClientRect().top - 1000;
                }

                return 1;
            };
        });
    }
}

InitWistiaVideo.init();